import classnames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Dropdown } from '@/components/shared/Dropdown';
import { ProjectClass } from '@/types/projectClass';
import * as styles from './ProjectClasses.module.scss';

export type Props = {
  error?: string;
  selectedClass: ProjectClass;
  projectClasses: ProjectClass[];
  setSelectedClass: (selectedClass: ProjectClass) => void;
};

export const ProjectClasses: React.FC<Props> = ({
  error,
  selectedClass,
  projectClasses,
  setSelectedClass,
}) => {
  const { t } = useTranslation();

  return (
    <div className="l-block">
      <div id="projectClass" className={classnames('field', { error })}>
        <label>{t('models.subscription.projectClass')}</label>
        <Dropdown
          dataTest="project-classes"
          text={selectedClass.name}
          buttonClassNames={styles.toggleButton}
          menuWrapperClassNames={styles.menuWrapper}
          menuNode={projectClasses.map((projectClass, i) => (
            <div
              key={projectClass.id}
              data-test={`project-class-dropdown-${i}`}
              className={classnames(
                styles.menuItem,
                selectedClass.id === projectClass.id && 'active',
              )}
              onClick={() => setSelectedClass(projectClass)}
            >
              {projectClass.name}
            </div>
          ))}
        />
      </div>
    </div>
  );
};
